import React, { Component } from 'react';
import EirButton from '../eir-button/EirButton';
import { currentUser } from '../../services/CurrentUser';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';

/*
  upgrade check object looks like:

  {
    number: 0871234567,
    id: 1
  }

*/

class UpgradeStatus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      upgradeCheck: currentUser.getAttribute(Constants.cacheKeys.upgradeCheck)
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    
    event.preventDefault();

    currentUser.removeAttribute(Constants.cacheKeys.upgradeCheck);

    // this is a fire and forget. we dont need a response from the server
    // the cookie and local storage is already deleted
    fetch(event.target.action, {
      method: event.target.method,
      body: new FormData(event.target)
    });

    PubSub.publish(Constants.eventKeys.upgradeStatusChanged, null);

    this.setState({
      upgradeCheck: null
    });
  }

  render() {
    if (this.props.visible) {
      if (this.state.upgradeCheck) {
        return (
          <h6 className={'text-black ' + this.props.className}>
            <span>{this.props.upgradeEligableText}</span>
            <strong>{this.state.upgradeCheck.number}</strong>
            <div className="d-inline-block ml-1">
              <form action="/store/api/upgrade/delete" method="post" onSubmit={this.handleSubmit}>
                <EirButton
                  className="align-baseline"
                  text={this.props.removeUpgradeCTAText}
                  type="link"
                  name="delete"
                  value="delete"
                />
              </form>
            </div>
          </h6>
        );
      } else {
        return (
          <h6 className={'text-black ' + this.props.className}>
            {this.props.linkToUpgradePageLabel && 
              <span className="d-inline-block mr-1">{this.props.linkToUpgradePageLabel}</span>
            }
            <div className="d-inline-block">
              <EirButton
                className="align-baseline"
                link={this.props.linkToUpgradePage.link}
                name="redirectTo"
                value={window.location.href}
                text={this.props.linkToUpgradePage.text}
                type={this.props.linkToUpgradePage.type}
              />
            </div>
          </h6>
        );
      }
    } else {
      return null;
    }
  }
}

export default UpgradeStatus;
